import * as tslib_1 from "tslib";
import handleBlockActionForShadowMailbox from '../../actions/helpers/handleBlockActionForShadowMailbox';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { lazyDiscardCompose } from 'owa-mail-compose-store';
import composeStore from 'owa-mail-compose-store/lib/store/composeStore';
import { getIsEverythingSelectedInTable } from 'owa-mail-list-store';
import { getRowIdsFromRowKeys, isDumpsterTable } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { searchStore, isDumpsterSearchTable } from 'owa-mail-search-store';
import folderStore from 'owa-folders';
import { NUMBER_OF_SELECTED_ITEMS_THRESHOLD } from 'owa-mail-store/lib/utils/bulkTriageConstants';
import { isGroupTableQuery } from 'owa-group-common';
import { isUnderDeletedItemsFolderFromAnyMailbox } from 'owa-mail-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { select } from 'satcheljs/lib/legacy';
import { mailSearchStore } from 'owa-mail-search';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isDeletedItemsFolderFromAnyMailbox } from 'owa-mail-store';
import { PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
export default select({
    originalTableView: function (conversationId, originalTableViewId) {
        return listViewStore.tableViews.get(originalTableViewId);
    },
    folderTable: function () { return folderStore.folderTable; },
    searchStore: function () {
        return isMailFeatureEnabled('sea-commonSearchBox') ? mailSearchStore : searchStore;
    },
})(function deleteMailListRowsHelper(rowKeys, originalTableViewId, isExplicitSoftDelete, deleteRowsInternal, isReplyingToOneOfRows, confirmDialogStrings, state) {
    var originalTableView = state.originalTableView;
    var tableQuery = originalTableView.tableQuery;
    var sourceFolderId = tableQuery.folderId;
    var areRowsUnderDeletedItems;
    var sourceFolderName;
    // Early return if the action is blocked for shadow mailbox
    if (handleBlockActionForShadowMailbox(sourceFolderId, null)) {
        return null;
    }
    var isGroupMailbox = isGroupTableQuery(tableQuery);
    var isSearchTable = tableQuery.type == 1 /* Search */;
    var isDumpster = isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
    if (isGroupMailbox) {
        areRowsUnderDeletedItems = false;
    }
    else if (isSearchTable) {
        // OW:12312 [Refactor]handle batch conversation triage in search scenarios more elegantly
        // if we are searching in the Deleted Items folder, we want to permanently delete
        areRowsUnderDeletedItems =
            state.searchStore.staticSearchScope.kind == 'Folder' &&
                (state.searchStore.staticSearchScope.folderId ==
                    folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID) ||
                    state.searchStore.staticSearchScope.folderId ==
                        folderNameToId(ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID));
        sourceFolderName = strings.searchFolderName; // "Search"
    }
    else if (!isDumpster) {
        var sourceFolder = state.folderTable.get(sourceFolderId);
        areRowsUnderDeletedItems =
            isDeletedItemsFolderFromAnyMailbox(sourceFolderId) ||
                isUnderDeletedItemsFolderFromAnyMailbox(sourceFolder);
        sourceFolderName = sourceFolder.DisplayName;
    }
    // Show confirm dialog for all group conversation deletions
    var isSoftDelete = isExplicitSoftDelete || areRowsUnderDeletedItems || isGroupMailbox;
    // Calculate whether we're above the selection count threshold in select all mode
    var selectionCountThresholdInSelectAll = rowKeys.length >= NUMBER_OF_SELECTED_ITEMS_THRESHOLD &&
        getIsEverythingSelectedInTable(originalTableView);
    /**
     * Determine title of confirmation dialog that'll be shown if we're above the
     * selection count threshold or if we're in a soft delete situation.
     */
    var title = rowKeys.length > 1
        ? format(confirmDialogStrings.deleteNumberOfRowsTitle, rowKeys.length)
        : confirmDialogStrings.deleteOneRowTitle;
    var subtext = isSoftDelete || isDumpster
        ? // "Do you want to permanently delete the selected items?"
            confirmDialogStrings.confirmDeleteRows
        : // "Are you sure you want to move all the selected items in [sourceFolderName] to Deleted Items?"
            format(strings.confirmEmptyFolderSubText, strings.allSelectedItems, sourceFolderName);
    var resolveImmediately = !isSoftDelete && !selectionCountThresholdInSelectAll && !isDumpster;
    return confirm(title, subtext, resolveImmediately /* resolveImmediately */, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === DialogResponse.ok) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the row keys again before performing delete
            var filteredRowKeys = rowKeys.filter(function (rowKey) {
                var idx = originalTableView.rowKeys.indexOf(rowKey);
                return idx >= 0;
            });
            // If in dumpster, hard delete always. Otherwise, soft delete or move to deleted items.
            var disposalType = isDumpster
                ? 'HardDelete'
                : isSoftDelete ? 'SoftDelete' : 'MoveToDeletedItems';
            if (filteredRowKeys.length > 0) {
                deleteRowsIfNotReplying(filteredRowKeys, originalTableView, disposalType, deleteRowsInternal, isReplyingToOneOfRows);
            }
        }
    });
});
/**
 * Proceeds to delete the given rows if user's not replying to one of the rows
 */
function deleteRowsIfNotReplying(rowKeys, originalTableView, disposalType, deleteRowsInternal, isReplyingToOneOfRows) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowIdStrings, filteredRowKeys;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);
                    if (!isReplyingToOneOfRows(rowIdStrings)) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyDiscardCompose.importAndExecute(composeStore.defaultViewState)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // Check isReplyingToOneOfRows for the second time to check the result of user's choice.
                    // If false, it means either
                    //    1. There's no compose for these rows at all, or
                    //    2. There was compose but user chose discard so compose was closed
                    // Then we can continue delete the rows
                    // If true, it means there is compose and user doesn't want to discard it. So we stop deleting now.
                    if (!isReplyingToOneOfRows(rowIdStrings)) {
                        filteredRowKeys = rowKeys.filter(function (rowKey) { return originalTableView.rowKeys.indexOf(rowKey) >= 0; });
                        if (filteredRowKeys.length > 0) {
                            deleteRowsInternal(rowKeys, disposalType);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=deleteMailListRowsHelper.js.map